import { useEffect } from "react"
import { Box, Button, Grid, Skeleton, Typography } from "@mui/material"
import EastIcon from '@mui/icons-material/East'
import { useNavigate } from "react-router-dom"
import { useCategory } from "../../../Categories"
import { usePlan } from "../../../Plans"
import { useInitReq } from "../../../InitReq"
import { ISettingsItem } from "../../../Settings"
import { useTranslation } from "../../../i18n"
import ChoosePlanText from "../right/ChoosePlanText"
import SelectCategory from "../right/SelectCategory"
import BenefitsApps from "../../BenefitsApps"
import BenefitsList from "../../BenefitsList"
import SliderPlans from "../right/SliderPlans"
import SelectPlanDetails from "../right/SelectPlanDetails"
import Details from "./Details"

export default function CategoryChoice({ name, variables }: ISettingsItem) {
  const { categories, ctgrIndex, ctgrClass, currentCategory, updateState } = useCategory()
  const { loadingPlan, currentPlan } = usePlan()
  const { loadingChipReq } = useInitReq()
  const { t } = useTranslation()
  const navigate = useNavigate()
  const defaultTextArray = [t.page1.chooseProfile1, t.page1.chooseProfile2]
  const { text = defaultTextArray, image = [] } = variables || {}
  const mergedArray = text
    ? text.map((value, index) => (value !== undefined && value !== "" ? value : defaultTextArray[index]))
    : defaultTextArray
  const categoryCardTitleTextArray = { text: mergedArray.slice(0, 2) }
  const ctgrImages = {
    KIDS: image[2],
    BUSINESS: image[3],
    GAMER: image[4],
    INFLUENCER: image[5],
    ESTUDANTE: image[6]
  }
  const ctgrTitle = {
    KIDS: image[7],
    BUSINESS: image[8],
    GAMER: image[9],
    INFLUENCER: image[10],
    ESTUDANTE: image[11]
  }
  const detailsTextArray = { text: [t.page1.bestSellersDefault1, t.page1.bestSellersDefault2] }
  const bnftsListArray = { text: currentCategory.beneficios }
  const bnftsAppsArray = { text: currentCategory.aplicativos, image: image.slice(12) }
  const portabilityVariables = {
    "text": [
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      'none',
      '',
      ''
    ]
  }

  useEffect(() => {
    const categoryNames = categories.map((category) => category.nome)
    updateState({ ctgrClass: categoryNames[ctgrIndex], currentCategory: categories[ctgrIndex] })
    // eslint-disable-next-line
  }, [categories, ctgrIndex])

  function handleNext() {
    navigate('/configure-seu-plano')
  }

  const currentImage = ctgrImages[ctgrClass as keyof typeof ctgrImages]
  const currentTitleImage = ctgrTitle[ctgrClass as keyof typeof ctgrTitle]

  return (
    <Grid item className={name ? `${name} category-choice` : "category-choice"}>
      <Grid className="ctgr-container">
        <Box className="planCategoryCard">
          <Box component="img" className="logo" src={image[ctgrClass === "BUSINESS" ? 1 : 0]} alt="Logo" />
          <ChoosePlanText name="category-card-title" variables={categoryCardTitleTextArray} />
          <SelectCategory name="mobile" />
          <SliderPlans name="mobile" />
          <SelectPlanDetails name="mobile" variables={portabilityVariables} />
          <Box className="ctgr-description-area">
            <Typography className="perfil-text" variant="body1" dangerouslySetInnerHTML={{ __html: t.page1.perfilLabel }} />
            {currentTitleImage ? <Box component="img" className="ctgr-title" src={currentTitleImage} alt="Título das categorias de planos" /> : null}
            <Typography className="description-text" variant="body1" dangerouslySetInnerHTML={{ __html: currentCategory.detalhes }} />
          </Box>
          <Box className="benefits">
            <BenefitsList variables={bnftsListArray} />
            <BenefitsApps variables={bnftsAppsArray} />
          </Box>
          {currentImage ? <Box className="background-img" component="img" src={currentImage} alt="Categorias de planos" /> : null}
        </Box>
      </Grid>
      <Details name="desktop" variables={detailsTextArray} />
      {!loadingPlan && !loadingChipReq ? (
        <Box className={`choose-ctgr ${categories[ctgrIndex].nome}`}>
          <Button onClick={handleNext} className="choose-ctgr-button">
            <Typography variant="body1" dangerouslySetInnerHTML={{ __html: `${categories[ctgrIndex].nome}: ${currentPlan.plano}` }} />
            <EastIcon />
          </Button>
        </Box>
      ) : (
        <Skeleton variant="rectangular" className="skltn-choose-ctgr" animation="wave" />
      )}
    </Grid>
  )
}
